import React from 'react';
import { useHistory } from 'react-router-dom';
import logoSeizo from '../images/logo-seizo.png';

const FONT      = '"Sofia Pro", "Helvetica Neue", Arial, sans-serif';
const TEXT_DARK = '#1a1f36';
const TEXT_LIGHT = '#6b7280';
const SEIZO_BLUE = '#00B0FF';
const SEIZO_BG   = '#f0f6fb';
const CARD_BG    = '#ffffff';

const Section = ({ title, children }) => (
    <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.15rem', fontWeight: '700', color: TEXT_DARK, fontFamily: FONT, marginBottom: '0.6rem', borderBottom: '2px solid #e8edf2', paddingBottom: '0.4rem' }}>
            {title}
        </h2>
        <div style={{ fontSize: '0.92rem', color: TEXT_DARK, lineHeight: 1.7, fontFamily: FONT }}>
            {children}
        </div>
    </div>
);

const MentionsLegales = () => {
    const history = useHistory();
    return (
        <div style={{ minHeight: '100vh', background: SEIZO_BG, fontFamily: FONT }}>
            {/* Header */}
            <header style={{ background: CARD_BG, borderBottom: '1px solid #e8edf2', padding: '1rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <a href="https://www.seizo.fr" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                    <img src={logoSeizo} alt="SEIZO" style={{ height: '44px', width: 'auto' }} />
                </a>
                <button onClick={() => history.push('/pricing')} style={{
                    background: SEIZO_BLUE, border: 'none', borderRadius: '8px',
                    padding: '0.55rem 1.4rem', cursor: 'pointer', fontSize: '0.9rem',
                    color: '#fff', fontFamily: FONT, fontWeight: '600',
                    boxShadow: '0 2px 8px rgba(0,176,255,0.25)',
                }}>
                    ← Retour
                </button>
            </header>

            {/* Contenu */}
            <div style={{ maxWidth: '820px', margin: '0 auto', padding: '3rem 1.5rem' }}>
                <h1 style={{ fontSize: '2rem', fontWeight: '800', color: TEXT_DARK, fontFamily: FONT, marginBottom: '0.4rem' }}>
                    Mentions légales &amp; Politique de confidentialité
                </h1>
                <p style={{ color: TEXT_LIGHT, fontSize: '0.85rem', marginBottom: '2.5rem', fontFamily: FONT }}>
                    Dernière mise à jour : mai 2026
                </p>

                <Section title="1. Éditeur du site">
                    <p>Le site <strong>SEIZO</strong> est édité par la société <strong>Toshiba TEIS France SAS</strong>, société par actions simplifiée au capital de 1 000 000 €, immatriculée au Registre du Commerce et des Sociétés sous le numéro SIREN 000 000 000, dont le siège social est situé à :</p>
                    <p style={{ margin: '0.8rem 0', paddingLeft: '1rem', borderLeft: '3px solid #e8edf2' }}>
                        Toshiba TEIS France SAS<br/>
                        [Adresse complète]<br/>
                        France
                    </p>
                    <p>Directeur de la publication : [Nom du directeur]<br/>
                    Contact : <a href="mailto:contact@seizo.fr" style={{ color: SEIZO_BLUE }}>contact@seizo.fr</a></p>
                </Section>

                <Section title="2. Hébergement">
                    <p>Le site est hébergé par :<br/>
                    <strong>[Nom de l'hébergeur]</strong><br/>
                    [Adresse de l'hébergeur]<br/>
                    [Site web de l'hébergeur]</p>
                </Section>

                <Section title="3. Propriété intellectuelle">
                    <p>L'ensemble des contenus présents sur le site SEIZO (textes, images, logos, graphismes, vidéos, etc.) sont la propriété exclusive de Toshiba TEIS France SAS ou de ses partenaires et sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle.</p>
                    <p>Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Toshiba TEIS France SAS.</p>
                </Section>

                <Section title="4. Données personnelles (RGPD)">
                    <p>Conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée, Toshiba TEIS France SAS est responsable du traitement des données personnelles collectées via la plateforme SEIZO.</p>

                    <p><strong>Données collectées :</strong></p>
                    <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.8rem' }}>
                        <li>Nom, prénom, adresse e-mail lors de la création de compte</li>
                        <li>Données de connexion (adresse IP, logs d'accès)</li>
                        <li>Données d'utilisation de la plateforme (écrans, widgets, workspaces)</li>
                        <li>Données de facturation (via Stripe, sous-traitant certifié PCI-DSS)</li>
                    </ul>

                    <p><strong>Finalités du traitement :</strong></p>
                    <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.8rem' }}>
                        <li>Gestion des comptes utilisateurs et des espaces SEIZO</li>
                        <li>Fourniture du service d'affichage dynamique</li>
                        <li>Facturation et gestion des abonnements</li>
                        <li>Amélioration de la plateforme et support technique</li>
                        <li>Envoi de communications liées au service (OTP, notifications)</li>
                    </ul>

                    <p><strong>Base légale :</strong> Exécution du contrat (article 6.1.b du RGPD) et intérêt légitime pour l'amélioration du service.</p>

                    <p><strong>Durée de conservation :</strong> Les données sont conservées pendant la durée de l'abonnement actif, puis 3 ans après la résiliation du compte pour les obligations légales.</p>

                    <p><strong>Vos droits :</strong> Conformément au RGPD, vous disposez des droits d'accès, de rectification, d'effacement, de portabilité, de limitation et d'opposition au traitement de vos données. Pour exercer ces droits, contactez-nous à : <a href="mailto:dpo@seizo.fr" style={{ color: SEIZO_BLUE }}>dpo@seizo.fr</a></p>

                    <p>Vous avez également le droit d'introduire une réclamation auprès de la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des Libertés) — <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color: SEIZO_BLUE }}>www.cnil.fr</a>.</p>
                </Section>

                <Section title="5. Cookies">
                    <p>La plateforme SEIZO utilise des cookies techniques strictement nécessaires au fonctionnement du service (authentification, préférences d'affichage). Aucun cookie publicitaire ou de tracking tiers n'est utilisé sans votre consentement explicite.</p>
                    <p>Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter le bon fonctionnement de la plateforme.</p>
                </Section>

                <Section title="6. Sous-traitants">
                    <p>SEIZO fait appel aux sous-traitants suivants pour la fourniture du service :</p>
                    <ul style={{ paddingLeft: '1.5rem' }}>
                        <li><strong>Stripe Inc.</strong> — traitement des paiements (certifié PCI-DSS)</li>
                        <li><strong>[Hébergeur]</strong> — hébergement des données</li>
                    </ul>
                    <p>Ces sous-traitants sont soumis à des obligations contractuelles conformes au RGPD.</p>
                </Section>

                <Section title="7. Contact">
                    <p>Pour toute question relative aux présentes mentions légales ou à la protection de vos données personnelles :<br/>
                    <a href="mailto:contact@seizo.fr" style={{ color: SEIZO_BLUE }}>contact@seizo.fr</a><br/>
                    <a href="https://www.seizo.fr" target="_blank" rel="noopener noreferrer" style={{ color: SEIZO_BLUE }}>www.seizo.fr</a></p>
                </Section>
            </div>

            {/* Footer */}
            <footer style={{ background: '#fff', borderTop: '1px solid #e8edf2', padding: '1.5rem 2rem', textAlign: 'center' }}>
                <span style={{ fontSize: '0.75rem', color: TEXT_LIGHT, fontFamily: FONT }}>© 2026 SEIZO — Toshiba TEIS France SAS. Tous droits réservés.</span>
            </footer>
        </div>
    );
};

export default MentionsLegales;
